








import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'

import ReagentsNotIncluded from '~/components/feature/PDP/ReagentsNotIncluded.vue'
import KitUsageInformation from '~/components/feature/PDP/KitUsageInformation.vue'
import Description from '~/components/feature/PDP/Description.vue'
import UsageInformation from '~/components/feature/PDP/UsageInformation.vue'
import Protocol from '~/components/feature/PDP/Protocol.vue'
import QualityControl from '~/components/feature/PDP/QualityControl.vue'
import SpecificityOrSensitivity from '~/components/feature/PDP/SpecificityOrSensitivity.vue'
import SourceOrPurification from '~/components/feature/PDP/SourceOrPurification.vue'
import Background from '~/components/feature/PDP/Background.vue'
import UpstreamOrDownstreamPathwayImage from '~/components/feature/PDP/UpstreamOrDownstreamPathwayImage.vue'
import DatabaseLinks from '~/components/feature/PDP/DatabaseLinks.vue'
import FluorescentProperties from '~/components/feature/PDP/FluorescentProperties.vue'

import { ProductInformationData } from '~/types/productInformation'

export default defineComponent({
  components: {
    ReagentsNotIncluded,
    KitUsageInformation,
    Description,
    UsageInformation,
    Protocol,
    QualityControl,
    SpecificityOrSensitivity,
    SourceOrPurification,
    Background,
    UpstreamOrDownstreamPathwayImage,
    DatabaseLinks,
    FluorescentProperties,
  },
  props: {
    componentsData: {
      type: Array as () => ProductInformationData[],
      required: false,
      default: () => [],
    },
  },
  setup() {
    return { isEmpty }
  },
})
